export function ValueProposition() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Certified Quality',
      description: 'Every vehicle under $30K undergoes our comprehensive safety inspection'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'No Hidden Fees',
      description: 'Transparent pricing with no dealer markup or surprise charges'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Oregon Dog Rescue Partner',
      description: 'Every purchase supports Oregon Dog Rescue - feel good about your investment'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Fair Trade-Ins',
      description: 'Get top dollar for your trade - no lowball offers'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Flexible Financing',
      description: 'Multiple lenders competing for your business means better rates'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Regional Delivery',
      description: 'Free delivery to Astoria, Long Beach, Seaside, and surrounding areas'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Why Buy Your $30K Car From Us?
          </h2>
          <p className="text-lg text-gray-600">
            We're not your typical dealership. No pressure, no games, just honest deals on quality vehicles.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
